export default __webpack_public_path__ + "faacafe5496c34617d281a5001c40d01.svg";